import type {
  LifeCycleCategory,
  LifeCycleProductsPagination,
  Period,
  PostTradeTabId,
  Region,
  RubricType,
} from 'state/discover/page/page.model';

export type DiscoverPageActions =
  | DiscoverRegionChanged
  | PostTradeTabChanged
  | RubricTypeChanged
  | RubricPeriodChanged
  | LifecyclePaginationChanged
  | LifecycleSelectedSectionChanged
  | LifecyclePageChanged
  | LifecyclePageSizeChanged
  | LifecycleSizeAndPageChanged;

export function discoverRegionChanged(region: Region) {
  return {
    type: 'DISCOVER_REGION_CHANGED' as const,
    region,
  };
}

export type DiscoverRegionChanged = ReturnType<typeof discoverRegionChanged>;

export function postTradeTabChanged(tabId: PostTradeTabId) {
  return {
    type: 'POST_TRADE_TAB_CHANGED' as const,
    tabId,
  };
}

export type PostTradeTabChanged = ReturnType<typeof postTradeTabChanged>;

export function rubricTypeChanged(rubricType: RubricType) {
  return {
    type: 'RUBRIC_TYPE_CHANGED' as const,
    rubricType,
  };
}

export type RubricTypeChanged = ReturnType<typeof rubricTypeChanged>;

export function rubricPeriodChanged(period: Period) {
  return {
    type: 'RUBRIC_PERIOD_CHANGED' as const,
    period: period,
  };
}

export type RubricPeriodChanged = ReturnType<typeof rubricPeriodChanged>;

export function lifecyclePaginationChanged(category: LifeCycleCategory, pagination: LifeCycleProductsPagination) {
  return {
    type: 'LIFECYCLE_PAGINATION_CHANGED' as const,
    pagination,
    category,
  };
}

export type LifecyclePaginationChanged = ReturnType<typeof lifecyclePaginationChanged>;

export function lifecyclePageChanged(category: LifeCycleCategory, page: number) {
  return {
    type: 'LIFECYCLE_PAGE_CHANGED' as const,
    page,
    category,
  };
}

export type LifecyclePageChanged = ReturnType<typeof lifecyclePageChanged>;

export function lifecyclePageSizeChanged(category: LifeCycleCategory, size: number) {
  return {
    type: 'LIFECYCLE_SIZE_CHANGED' as const,
    category,
    size,
  };
}

export type LifecyclePageSizeChanged = ReturnType<typeof lifecyclePageSizeChanged>;

export function lifecycleSizeAndPageChanged(category: LifeCycleCategory, size: number, page: number) {
  return {
    type: 'LIFECYCLE_SIZE_AND_PAGE_CHANGED' as const,
    category,
    size,
    page,
  };
}

export type LifecycleSizeAndPageChanged = ReturnType<typeof lifecycleSizeAndPageChanged>;

export function lifecycleSelectedSectionChanged(category: LifeCycleCategory) {
  return {
    type: 'LIFECYCLE_SELECTED_SECTION_CHANGED' as const,
    category,
  };
}

export type LifecycleSelectedSectionChanged = ReturnType<typeof lifecycleSelectedSectionChanged>;
